export enum DigitalSignStatusEnum {
  CANCELADO = "Cancelado",
  A_ASSINAR = "A Assinar",
  ASSINADO_NIMBER = "Assinado Nimber",
  ASSINADO_COLABORADOR = "Assinado Colaborador",
}
